"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("./styles/_difficulty-dropdown.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var DIFFICULTY_RATINGS = {
  EASY: {
    label: 'Easy',
    color: '#1aa260'
  },
  MODERATE: {
    label: 'Moderate',
    color: '#ff9f19'
  },
  HARD: {
    label: 'Hard',
    color: '#ff0000'
  },
  UNKNOWN: {
    label: 'Unknown',
    color: '#cbd0db'
  }
};

var getDifficultyRatingOption = function getDifficultyRatingOption(value) {
  if (!DIFFICULTY_RATINGS[value]) {
    return 'Select difficulty';
  }

  return {
    label: DIFFICULTY_RATINGS[value].label,
    value: value,
    prefix: /*#__PURE__*/_react.default.createElement("div", {
      style: {
        backgroundColor: DIFFICULTY_RATINGS[value].color
      },
      className: "difficulty-dropdown__indicator"
    })
  };
};

function DifficultyDropdown(_ref) {
  var defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      updateDifficulty = _ref.updateDifficulty;
  return /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
    id: "difficulty-rating",
    className: "difficulty-dropdown",
    defaultValue: getDifficultyRatingOption(defaultValue),
    onChange: updateDifficulty,
    options: Object.keys(DIFFICULTY_RATINGS).map(getDifficultyRatingOption),
    disabled: disabled
  });
}

var _default = (0, _react.memo)(DifficultyDropdown);

exports.default = _default;